import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
import styled from "styled-components";
import Header from "@/components/main/Header";
import Banner from "@/components/learn/Banner";
import TileBanner from "@/components/learn/TileBanner";
import Footer from "@/components/main/Footer";

const YoutubeWrap = styled.div`
  margin: 50px auto;
  max-width: 1240px;

  @media (max-width: 1200px) {
    padding: 0 20px;
  }
`;
const IframeWrap = styled.div`
  position: relative;
  padding-top: 56.25%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const IFrame = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
`;

const Steps = styled.div`
  display: flex;
  margin: 0 auto;
  max-width: 1240px;
  width: 100%;

  @media (max-width: 1000px) {
    flex-direction: column;
    padding: 0 20px;
  }
`;
const StepTitleWrap = styled.div`
  position: sticky;
  top: 70px;
  left: 0;
  padding: 30px 50px 0 0;
  width: 33.333%;
  height: 100%;

  @media (max-width: 1000px) {
    position: initial;
    margin: 0 0 20px 0;
    width: 100%;
  }
`;
const StepSubTitle = styled.p`
  font-family: "Hind", sans-serif;
  font-size: 16px;
  color: #000;

  @media (max-width: 1000px) {
    text-align: center;
  }
`;
const StepTitle = styled.p`
  font-family: "Lato Bold", sans-serif;
  font-size: 44px;
  line-height: 48px;
  font-weight: 700;
  @media (max-width: 1000px) {
    text-align: center;
  }
`;
const StepItemsWrap = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  width: 66.666%;

  @media (max-width: 1000px) {
    width: 100%;
  }
`;
const StepItem = styled.div`
  margin: 20px 10px;
  padding: 40px 40px 30px 40px;
  width: calc(50% - 20px);
  background-color: #fff;
  border: 1px solid #971b2f;
  border-radius: 10px;

  @media (max-width: 1000px) {
    margin: 10px 0;
    width: 100%;
  }
`;
const StepItemImg = styled.img`
  max-width: 66px;
`;
const StepItemTitle = styled.p`
  margin: 10px 0 50px 0;
  font-family: "Lato Bold", sans-serif;
  font-size: 32px;
  font-weight: 700;
  color: #444;
`;
const StepItemDesc = styled.p`
  line-height: 26px;
  font-family: "Hind", sans-serif;
  font-size: 16px;
  color: #676767;
`;

export default function Page() {
  const { t } = useTranslation();
  const router = useRouter();

  const steps = [
    {
      icon: "/learn/inbody-test-procedures/Test_Procedures-01.webp",
      desc: t("menu.learn.inbody-test-procedures.step-1.desc"),
    },
    {
      icon: "/learn/inbody-test-procedures/Test_Procedures-02.webp",
      desc: t("menu.learn.inbody-test-procedures.step-2.desc"),
    },
    {
      icon: "/learn/inbody-test-procedures/WhatsApp-Image-2024-06-20-at-14.12.10-1.webp",
      desc: t("menu.learn.inbody-test-procedures.step-3.desc"),
    },
    {
      icon: "/learn/inbody-test-procedures/Test_Procedures-03.webp",
      desc: t("menu.learn.inbody-test-procedures.step-4.desc"),
    },
    {
      icon: "/learn/inbody-test-procedures/WhatsApp-Image-2024-06-20-at-14.12.10.webp",
      desc: t("menu.learn.inbody-test-procedures.step-5.desc"),
    },
  ];

  return (
    <>
      <Header />
      <Banner Bg="/learn/banner/InBody_Test_Procedures.webp" Headline="Learn" Title="InBody Test Procedures" />
      <YoutubeWrap>
        <IframeWrap>
          <IFrame
            loading="lazy"
            src={"https://www.youtube.com/embed/fBXQeh6J9aE?feature=oembed&enablejsapi=1&origin=https://inbodyasia.com"}
          />
        </IframeWrap>
      </YoutubeWrap>

      <Steps>
        <StepTitleWrap>
          <StepSubTitle>{t("menu.learn.inbody-test-procedures.sub-title")}</StepSubTitle>
          <StepTitle>{t("menu.learn.inbody-test-procedures.title")}</StepTitle>
        </StepTitleWrap>
        <StepItemsWrap>
          {steps.map((v, i) => (
            <StepItem key={i}>
              <StepItemImg src={v.icon} />
              <StepItemTitle
                data-aos="fade-up"
                data-aos-easing="ease-out"
                data-aos-delay="400"
                data-aos-duration="500"
              >{`${t("menu.learn.inbody-test-procedures.step")} ${i + 1}`}</StepItemTitle>
              <StepItemDesc data-aos="fade-up" data-aos-easing="ease-out" data-aos-delay="300" data-aos-duration="500">
                {v.desc}
              </StepItemDesc>
            </StepItem>
          ))}
        </StepItemsWrap>
      </Steps>

      <TileBanner
        backgroundImg={"/learn/inbody-test-procedures/Mask-group-7.png"}
        backgroundColor="#971b2f"
        title={t("menu.learn.inbody-test-procedures.tile-banner.title")}
        desc={t("menu.learn.inbody-test-procedures.tile-banner.desc")}
        btn={{
          text: t("menu.learn.inbody-test-procedures.tile-banner.btn"),
          onClick: () => {
            router.push("/learn/body-composition-result-sheet");
          },
        }}
        negative
      />
      <Footer />
    </>
  );
}
